import { EmployeeSelect } from '@/components/selects';
import type { EmployeeResponse } from '@/types/employee';
import { cn } from '@/utils/cn';

type ApprovalDelegateEmployeeSelectProps = {
  value: string;
  onChange: (employeeId: string) => void;
  onEmployeeChange?: (employee: EmployeeResponse | null) => void;
  excludeUserId?: number;
  label?: string;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  className?: string;
  compact?: boolean;
};

export function ApprovalDelegateEmployeeSelect({
  value,
  onChange,
  onEmployeeChange,
  excludeUserId,
  label = 'Delegate to',
  placeholder,
  required,
  disabled,
  className,
  compact = false,
}: ApprovalDelegateEmployeeSelectProps) {
  return (
    <EmployeeSelect
      label={compact ? undefined : label}
      value={value}
      onChange={onChange}
      onEmployeeChange={onEmployeeChange}
      placeholder={placeholder}
      required={required}
      disabled={disabled}
      activeOnly
      approvalDelegateScope
      hrScoped={false}
      excludeUserId={excludeUserId}
      pageSize={200}
      className={cn(compact ? 'min-w-0' : undefined, className)}
      hint={
        compact
          ? undefined
          : 'All company employees except you. Selected employee must have a login to receive delegations.'
      }
    />
  );
}
